import React, { useEffect, useState } from "react";
import "../../Styles/Parentsnotification.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";

export default function Parentnotification() {
    const [isLoading, setIsLoading] = useState(false);
    
    // State to manage individual checkbox values
    const [settings, setSettings] = useState({
        busfare: false,
        cashless: false,
        fee_reminder1: false,
        fee_reminder2: false,
        fee_reminder3: false
    });

    useEffect(() => {
        notificationgetSettings();
    }, []);

    // Helper to handle checkbox changes
    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setSettings((prev) => ({
            ...prev,
            [id]: checked
        }));
    };

    const notificationgetSettings = async () => {
        setIsLoading(true);
        const customer_id = localStorage.getItem("customer_id");
        const api_key = localStorage.getItem("api_key");

        const requestBody = {
            customer_id: Number(customer_id),
            api_key: api_key,
            language: "en",
            user_id: localStorage.getItem("user_id") || "" 
        };

        try {
            const response = await simplePostCall(ApiConfig.parentintegrationsettingsget, JSON.stringify(requestBody));

            if (response?.result && response?.model?.length > 0) {
                const data = response.model[0];
                // Mapping API 1/0 to Boolean
                setSettings({
                    busfare: data.notification_settings_busfare === 1,
                    cashless: data.notification_settings_cashless === 1,
                    fee_reminder1: data.notification_settings_fee_reminder1 === 1,
                    fee_reminder2: data.notification_settings_fee_reminder2 === 1,
                    fee_reminder3: data.notification_settings_fee_reminder3 === 1,
                });
            }
        } catch (error) {
            console.error("Error loading settings:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const notificationgetSettingsUpdate = async () => {
        setIsLoading(true);
        const customer_id = localStorage.getItem("customer_id");
        const api_key = localStorage.getItem("api_key");
        const user_id = localStorage.getItem("user_id");

        // Constructing the specific payload format you requested
        const requestBody = {
            customer_id: Number(customer_id),
            api_key: api_key,
            language: "en",
            user_id: Number(user_id),
            activity_type: "UPDATE",
            activity_action: "Notification Settings Updated",
            NotificationSettings: [
                {
                    settings_busfare: settings.busfare ? 1 : 0,
                    settings_cashless: settings.cashless ? 1 : 0,
                    settings_fee_reminder1: settings.fee_reminder1 ? 1 : 0,
                    settings_fee_reminder2: settings.fee_reminder2 ? 1 : 0,
                    settings_fee_reminder3: settings.fee_reminder3 ? 1 : 0
                }
            ]
        };

        try {
            const response = await simplePostCall(ApiConfig.parentintegrationsettingsUpdate, JSON.stringify(requestBody));

            if (response?.result) {
                alert("Well done! Notification Settings saved successfully");
                notificationgetSettings()
            } else {
                alert("Failed to update settings");
            }
        } catch (error) {
            console.error("Error updating settings:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="parentnotification-container">
            <div className="col-md-12">
                <div className="special-header panel-white-all mb-4">
                    <h4 className="page-title parent-title">Parents Notification Settings</h4>
                </div>
            </div>
            <div className="row parent-row-bg">
                <div className="panel-body">
                    <div className="col-md-12">
                        <div className="page-title">
                            <h5>Parents Notification Settings</h5>
                        </div>
                        <div className="row">
                            {/* Busfares Checkbox */}
                            <div  className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="busfare"
                                    className="big-checkbox"
                                    checked={settings.busfare}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="busfare" className="custom-checkbox-label">
                                    Notification for busfares
                                </label>
                            </div>

                            {/* Cashless Checkbox */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                
                                    type="checkbox"
                                    id="cashless"
                                    className="big-checkbox"
                                    checked={settings.cashless}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="cashless" className="custom-checkbox-label">
                                    Notification Related Cashless System
                                </label>
                            </div>

                            {/* Reminder 1 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder1"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder1}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder1" className="custom-checkbox-label">
                                    Pending Fee first reminder (parents)
                                </label>
                            </div>

                            {/* Reminder 2 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder2"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder2}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder2" className="custom-checkbox-label">
                                    Pending Fee second reminder (parents, class, teacher)
                                </label>
                            </div>

                            {/* Reminder 3 */}
                            <div className="col-lg-6 col-md-12 checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="fee_reminder3"
                                    className="big-checkbox"
                                    checked={settings.fee_reminder3}
                                    onChange={handleCheckboxChange}
                                />
                                <label htmlFor="fee_reminder3" className="custom-checkbox-label">
                                    Pending Fee third reminder (parents, class teacher, accountant)
                                </label>
                            </div>

                            <div className="update-button d-flex justify-content-end">
                                <button
                                    className="btn custom-btn"
                                    onClick={notificationgetSettingsUpdate}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Updating..." : "Update"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}